import { render, staticRenderFns } from "./job-information.vue?vue&type=template&id=35d21bab&scoped=true&"
import script from "./job-information.vue?vue&type=script&lang=js&"
export * from "./job-information.vue?vue&type=script&lang=js&"
import style0 from "./job-information.vue?vue&type=style&index=0&id=35d21bab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d21bab",
  null
  
)

export default component.exports